module.exports = __webpack_public_path__ + "img/example-left-hand-side_2.329194dc.png";